"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductView = void 0;
var ProductView;
(function (ProductView) {
    ProductView["List"] = "list";
    ProductView["Tile"] = "tile";
})(ProductView = exports.ProductView || (exports.ProductView = {}));
//# sourceMappingURL=product-view.js.map